export const getNumberValue = (value: unknown): number => (typeof value === 'number' && !isNaN(value) ? value : 0);
